// hooks/useWebSocket.js
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef } from "react";
import {
  connectWebSocket,
  disconnectWebSocket,
  sendWebSocketMessage,
} from "../store/chats/slice";

export const useWebSocket = (url) => {
  const dispatch = useDispatch();
  const { isConnected } = useSelector((state) => state?.chats);

  useEffect(() => {
    dispatch(connectWebSocket());

    return () => {
      dispatch(disconnectWebSocket());
    };
  }, [url, dispatch]);

  const sendMessage = useCallback((data) => {
    dispatch(sendWebSocketMessage(data));
  }, []);

  return { isConnected, sendMessage };
};
